import type { LabeledStat } from '@/components/common/StatCardGrid';
import { TAKA_SYMBOL } from '@/constants/app.constants';
import type { ApprovalAmountTotals, WorkSummary } from '../types/dashboard.types';

export type WorkSummaryTab = 'dcr' | 'expenses';

const TOTALS_LABEL: Record<WorkSummaryTab, string> = {
  dcr: 'Fare',
  expenses: 'Expense',
};

const STATUS_CARDS: { key: keyof ApprovalAmountTotals; label: string }[] = [
  { key: 'approved', label: 'Approved' },
  { key: 'pending', label: 'Pending' },
  { key: 'rejected', label: 'Rejected' },
];

export function getWorkSummaryStatCards(
  totals: WorkSummary['totals'] | undefined,
  tab: WorkSummaryTab,
): LabeledStat[] {
  const tabTotals = tab === 'dcr' ? totals?.dcr : totals?.expenses;
  return STATUS_CARDS.map((card) => ({
    key: `${tab}-${card.key}`,
    label: `${card.label} ${TOTALS_LABEL[tab]}`,
    value: tabTotals?.[card.key],
    unit: TAKA_SYMBOL,
  }));
}
